import type { ToolbarPlacement } from '../types/toolbar.js';

/**
 * Returns true if legendPosition is a valid LegendPosition
 * @param legendPosition -
 */
export const isValidToolbarPlacement = (
  toolbarPlacement: string | undefined,
): toolbarPlacement is ToolbarPlacement =>
  ['top-right', 'top-left', 'bottom-right', 'bottom-left'].includes(
    toolbarPlacement ?? '',
  );
